import { render, staticRenderFns } from "./siteTotalPie.vue?vue&type=template&id=68e7e76a&"
import script from "./siteTotalPie.vue?vue&type=script&lang=js&"
export * from "./siteTotalPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports